import $ from 'jquery';
import { commonMiddleware, protectRoute } from '../middleware';
import { initHomeExperience } from '~src/home';
import { initSidebarProfile } from '../../sidebar-profile';
import { trackPageView } from '~src/tracking';
import { isFeatureEnabled } from '~src/features';
import { router } from '~src/router';
import React from 'react';
import ReactDOM from 'react-dom';
import { ProductsPage } from '~src/components/Products';

export const productsRoute = async () => {
  document.title = 'Prodotti | Giotto';

  await protectRoute();
  await commonMiddleware();

  // Guard route by feature flag
  try {
    const allowed = await isFeatureEnabled('giotto.show_products');
    if (!allowed) {
      router.navigate('/');
      return;
    }
  } catch (e) {
    // On failure, be safe and deny access
    try {
      router.navigate('/');
    } catch (err) {
      // ignore navigate errors explicitly
      void 0;
    }
    return;
  }

  // Ensure the window is at the top before rendering
  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  } catch (e) {
    // no-op
  }

  // Hide app navbars for dashboard layout consistency
  $('#navbar-private').hide();
  $('#navbar-canvas').hide();
  $('.logo').hide();

  // Show Products route
  $('#route-products').show();

  // Match Projects behavior: let the document scroll; keep sidebar sticky
  $('body').removeClass('dashboard dashboard-sidebar-open');

  // Setup responsive sidebar interactions and profile menu
  initHomeExperience();
  initSidebarProfile();

  // Render products
  const domContainer = document.querySelector('#products-root');
  ReactDOM.render(React.createElement(ProductsPage), domContainer);

  // Pageview tracking
  trackPageView('Products');
};
